var map = {
	"./10k.svg": 9264,
	"./50kDS.svg": 5012,
	"./Capa_1.svg": 9915,
	"./Collectionmethodology.png": 2152,
	"./Dataqualityscore.png": 5229,
	"./Datasources.png": 1741,
	"./Download.png": 1726,
	"./Download.webp": 5118,
	"./Downloadwhitetransparent.png": 9863,
	"./Downloadwhitetransparent.webp": 8951,
	"./Filter.png": 2982,
	"./Filter.webp": 185,
	"./Frame7974.svg": 819,
	"./Group1000002491.svg": 2366,
	"./Group1000002511.svg": 2602,
	"./Group6577.svg": 8619,
	"./Group6578.svg": 8126,
	"./Group6579.svg": 348,
	"./Group6591.svg": 6281,
	"./Group6602.svg": 5315,
	"./Group6602Mobile.svg": 1159,
	"./Layer_1.svg": 2432,
	"./Matchdatatoanalysis-sketch.png": 6534,
	"./Matchdatatoanalysis.png": 7701,
	"./Preview.png": 2271,
	"./Preview.webp": 623,
	"./Search.png": 9478,
	"./Search.webp": 3099,
	"./arrowLeft.svg": 8215,
	"./arrowRight.svg": 5767,
	"./brandImgMobile.svg": 3370,
	"./checkTime.svg": 2862,
	"./collectionMethodology.svg": 9562,
	"./dqScore.svg": 2388,
	"./emptyFile.svg": 7866,
	"./emptyHeaders.svg": 5954,
	"./fdFaster.svg": 7793,
	"./fifthLine.svg": 7125,
	"./file50k.svg": 8470,
	"./filterDataSource.svg": 3801,
	"./filterResults.svg": 6554,
	"./firstLine.svg": 548,
	"./fourthLine.svg": 192,
	"./logo-linkedin.svg": 5341,
	"./logo-twitter.svg": 7029,
	"./logo-youtube.svg": 824,
	"./matchDataToAnalysis.svg": 1538,
	"./oceanFigma.gif": 333,
	"./oldSignUp.svg": 4569,
	"./padLock.svg": 8852,
	"./preCatData.svg": 1810,
	"./productHero.svg": 2020,
	"./researcher1.svg": 8333,
	"./researcher2.svg": 1433,
	"./researcher3.svg": 5100,
	"./searchData.svg": 5492,
	"./searchEmpty.svg": 7265,
	"./secondLine.svg": 2849,
	"./siftBanner.svg": 408,
	"./sifteeWhite.svg": 4535,
	"./signIn.svg": 9880,
	"./signInTablet.svg": 5089,
	"./signUp.png": 1917,
	"./signUpBrands.svg": 9091,
	"./tableViewScoreVector.svg": 8923,
	"./thirdLine.svg": 7972
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2286;